export const validarVendaFutura = ({ quantidade_compra, quantidade_sugestao, quantidade_venda_futura }) => {
  if (Number(quantidade_venda_futura || 0) === 0) {
    return true;
  }

  return Number(quantidade_compra) >= (Number(quantidade_sugestao) + Number(quantidade_venda_futura));
}
